import { render, staticRenderFns } from "./BaseAttribute.vue?vue&type=template&id=76615d72&scoped=true"
import script from "./BaseAttribute.vue?vue&type=script&lang=js"
export * from "./BaseAttribute.vue?vue&type=script&lang=js"
import style0 from "./BaseAttribute.vue?vue&type=style&index=0&id=76615d72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76615d72",
  null
  
)

/* custom blocks */
import block0 from "./BaseAttribute.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports